import style from './Filter.module.scss'
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { setContent, setFetching, setTotalCount } from '../../redux/contentSlices/ContentSlices';
import { setMinRating, setOrdering, setSortingBy, setType } from '../../redux/filterSlices/FilterSlices';
import { selectFilter } from '../../redux/filterSlices/FilterSelector'
import { selectHeader } from '../../redux/headerSlices/HeaderSelector'


let Filter = () => {

    var dispatch = useDispatch()

    const { type, minRating, ordering, sortingBy } = useSelector(selectFilter)

    const { search } = useSelector(selectHeader)

    let FilterMovie = () => {
        dispatch(setFetching(false))
        try {
            axios.get(`https://yts.mx/api/v2/list_movies.json?quality=${type}&limit=48&minimum_rating=${minRating}&page=1&sort_by=${sortingBy}&order_by=${ordering}&query_term=${search}`)
                .then(response => {
                    if (response.data.data.movies) {
                        dispatch(setContent(response.data.data.movies))
                        dispatch(setTotalCount(response.data.data.movie_count))
                        dispatch(setFetching(true))
                    } else {
                        alert(`No movie with the same name was found,try lowering the quality of the movie`)
                    }
                })
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className={style.Filter}>
            <div className={style.Filter__type}>
                <span>Sort by: </span>
                <button className={ordering === 'desc' ? style.Button_active : style.Filter__button} onClick={() => dispatch(setOrdering('desc'))}> Decreasing </button >
                <button className={ordering === 'asc' ? style.Button_active : style.Filter__button} onClick={() => dispatch(setOrdering('asc'))}>Ascending </button >
            </div>
            <div className={style.Filter__type}>
                <span> Quality: </span>
                <button className={type === '720p' ? style.Button_active : style.Filter__button} onClick={() => dispatch(setType('720p'))}>720p</button >
                <button className={type === '1080p' ? style.Button_active : style.Filter__button} onClick={() => dispatch(setType('1080p'))}>1080p</button>
                <button className={type === '2160p' ? style.Button_active : style.Filter__button} onClick={() => dispatch(setType('2160p'))}>2160p</button>
                <button className={type === '3D' ? style.Button_active : style.Filter__button} onClick={() => dispatch(setType('3D'))}>3D</button>
            </div>
            <div className={style.Filter__type}>
                <span> Sorting by: </span>
                <button className={sortingBy === 'download_count' ? style.Button_active : style.Filter__button} onClick={() => dispatch(setSortingBy('download_count'))}>
                    Number of downloads </button >
                <button className={sortingBy === 'like_count' ? style.Button_active : style.Filter__button} onClick={() => dispatch(setSortingBy('like_count'))}>
                    Number of likes </button >
            </div>
            <div className={style.Filter__type}>
                <span> Least rating: </span>  <input value={minRating} onChange={e => dispatch(setMinRating(e.target.value))} placeholder='Enter the minimum rating 1 - 10 ' />
            </div>
            <div className={style.Filter__search}>
                <button type='button' onClick={FilterMovie} className={style.Filter__button}>Search</button >
            </div>
        </div>
    )
}

export default Filter;